
<my-portal-restricted-area-reserve></my-portal-restricted-area-reserve>
<my-portal-restricted-area-fidelity></my-portal-restricted-area-fidelity>
